import { ReactQueryDevtoolsPanel } from "@tanstack/react-query-devtools"

export const Devtools = {
  name: "Tanstack Query",
  render: <ReactQueryDevtoolsPanel />,
}
